import React from 'react'

// local components
import EFSFooter from './EFSFooter'

const Footer = props => {
  const { bhParam, brand } = props

  return (
    <>
      {bhParam === 'efs' && <EFSFooter brand={brand} />}
    </>
  )
}

export default Footer
